import { render, staticRenderFns } from "./createTaskModal.vue?vue&type=template&id=1f0790ca&scoped=true"
import script from "./createTaskModal.vue?vue&type=script&lang=js"
export * from "./createTaskModal.vue?vue&type=script&lang=js"
import style0 from "./createTaskModal.vue?vue&type=style&index=0&id=1f0790ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0790ca",
  null
  
)

export default component.exports